export default {
    pages: {
        103: [
            {
                id: '813340', // text_node.
                attributes: [
                    {
                        /* This is a rare case where a text-node is bleeding through an image.
                        *  Normally, images don't cover text. We set z-index to 0 so that the text is no longer visible
                        *  after an action enables the image to cover the text.
                        * */
                        name: 'zIndexOverride',
                        value: '0'
                    },
                ]
            },
        ],
        508: [
            {
                id: '821672', // answers_node
                attributes: [
                    {
                        name: 'zIndex',
                        value: '2'
                    },
                    {
                        name: 'height',
                        value: '70'
                    }
                ]
            },
            {
                id: '829699', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: '2'
                    },
                ]
            },
        ],
        315: [
            {
                id: '825046', // text_node
                attributes: [
                    {
                        name: 'height',
                        value: '100'
                    }
                ]
            },
        ],
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.IDIN.3.0.1.js